export default () => ({
  isContentLoaded: false,
  heroContent: {},
  descriptionContent: {},
  listTitleContent: {},
  listBulletContent: {},
  imageContent: {},
  footerContent: {},
});
